import { toastConfig } from 'config';
import GraphForm from './graph-form';
import { Grid } from '@mui/material';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import MainCard from 'components/MainCard';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import comptroller from 'assets/images/comptroller_white.svg';
import ComptrollerConfirmModal from '../ComptrollerConfirmModal';
import DetailPageHeader from 'components/header/DetailPageHeader';
import ActiveEditButton from 'components/button/ActiveEditButton';
import { useAddGraphDefinationMutation, useGetGraphDefinationByIdMutation } from 'store/features/comptroller/comptrollerApi';
import SectionCard from 'components/section/SectionCard';

function DetailsGraph() {
	const state = useLocation();
	const navigate = useNavigate();

	const [formData, setFormData] = useState(null);
	const [modalInfo, setModalInfo] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [submitData, setSubmitData] = useState(null);
	const [submitForm, setSubmitForm] = useState(false);

	const companyCode = useSelector((state) => state?.profile?.profileData?.creatorOrganizationId);

	const [AddGraphDefination, { data: graphDefinationData, isLoading }] = useAddGraphDefinationMutation();
	const [GetGraphDefinationById, { data: graphDefinationById, isLoading: isLoadingById }] = useGetGraphDefinationByIdMutation();

	const handleModalSubmit = (data) => {
		setSubmitData(data);
		setShowModal(true);

		setModalInfo({
			head: 'Module',
			action: 'submit',
		});
	};

	const submitHandle = (formData) => {
		const payload = {
			id: state?.state?.id,
			companyCode: companyCode,
			graphName: formData.graphName,
			graphDescription: formData.graphDescription,
			graphType: formData.graphType,
			graphQuery: formData.graphQuery,
		};
		AddGraphDefination(payload);
	};

	useEffect(() => {
		if (state?.state?.id) {
			GetGraphDefinationById({ id: state?.state?.id });
		}
	}, [state]);

	useEffect(() => {
		if (graphDefinationById) {
			if (graphDefinationById?.code === '200') {
				setFormData(graphDefinationById);
			} else {
				toast.error('Failed to fetch Graph Defination', toastConfig);
			}
		} //eslint-disable-next-line
	}, [graphDefinationById]);

	useEffect(() => {
		if (submitForm && submitData && companyCode) {
			submitHandle(submitData);
		} //eslint-disable-next-line
	}, [submitForm]);

	useEffect(() => {
		if (graphDefinationData) {
			if (graphDefinationData?.code === '200') {
				toast.success('Graph Defination Added Successfully', toastConfig);
				navigate(-1);
			} else {
				toast.error('Failed to add Graph Defination', toastConfig);
			}
		} //eslint-disable-next-line
	}, [graphDefinationData]);

	const childernOne = (
		<>
			<GraphForm
				handleModalSubmit={handleModalSubmit}
				formData={formData}
				isLoading={isLoadingById || isLoading}
				formDisabled={true}
			></GraphForm>
			<ActiveEditButton
				editNavigation={() => {
					navigate('/comptroller/graph-defination/edit', { state: { id: state?.state?.id } });
				}}
			/>
		</>
	);

	return (
		<Grid container rowSpacing={4.5} columnSpacing={2.75}>
			<Grid item xs={12}>
				<DetailPageHeader title="View Graph Defination" />

				<SectionCard>{childernOne}</SectionCard>

				{showModal && (
					<ComptrollerConfirmModal showModal={showModal} setShowModal={setShowModal} setSubmitForm={setSubmitForm} modalData={modalInfo} />
				)}
			</Grid>
		</Grid>
	);
}

export default DetailsGraph;
